module.exports = {
      id: "ic-theme-dark-usage",
      viewBox: "0 0 236 180",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-theme-dark-usage",
      toString: function () {
        return this.url;
      }
    }